<template>
  <div class="routerview">
    <el-card class="box-card">
        <template #header>
            <div class="card-header"
                 v-for="item in headers">
               {{item[3]}}
            </div>
        </template>
        <div class="card-body" v-for="item in research">{{item.research}}</div>
    </el-card>
  </div>
</template>


<script>
    import config from '../config.js';
    import axios from 'axios'

    export default {
        name: "Reaserch",
        created() {
            const _this =this;
            let server = config.apiser;
            axios.get(server+'/homepage/research').then(res =>{
                _this.research = res.data
            })
        },
        data(){
            return {
                headers:[
                         {0: '概况'},
                         {1: '教育经历'},
                         {2: '工作经历'}, 
                         {3: '项目'}, 
                         {4: '论著'}, 
                         {5: '奖励'}, 
                         {6: '课程'}, 
                         {7: '成员'} 
                        ],
                research: null,
                includeResearch: null,
                excudeResearch: null,
            }
        }
    }
</script>


<style scoped src='@/assets/css/globalcn.css'>
</style>
